import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-heading-1",
  "use": "icon-heading-1-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-heading-1\">\n    <path d=\"M5.25586 16V7.54492H7.02539V10.9785H10.834V7.54492H12.6035V16H10.834V12.4375H7.02539V16H5.25586ZM16.5527 16V9.21484H16.4473L14.373 10.6562V9.0625L16.5586 7.54492H18.3223V16H16.5527Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol